export default __webpack_public_path__ + "static/media/farmoptimizer-logo-text-only.a621c3d6.png";